module.exports = __webpack_public_path__ + "static/media/walletnew loanx3.9d64f76b.svg";